import type { UserProcessInfoDto } from '@/api/generated';

import ArrowRightSvg from '@/assets/ArrowRightSvg.svg';
import HappyRobotSvg from '@/assets/HappyRobotSvg.svg';
import ButtonWithLoading from '@/components/ButtonWithLoading.comp.tsx';
import DialogDesktop from '@/components/dialog/DialogDesktop.tsx';
import { generateNonCachableImageSrc } from '@/utils/generateNonCachableImageSrc.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import React from 'react';

export interface FinalMessageProps {
  handleFinish: (event: React.FormEvent) => void;
  processInfo?: UserProcessInfoDto;
}

const FinalMessageDesktop: React.FC<FinalMessageProps> = ({ handleFinish, processInfo }) => {
  const { t } = useTranslationWithPrefix('skillsAssessmentCollectedPage');

  return (
    <div className="flex gap-4 mt-20 align-items-center">
      <div className="relative flex-1 flex flex-col justify-center items-center gap-14">
        <DialogDesktop
          arrow={
            <img
              alt="arrow-down"
              className="absolute -z-10 -right-10 bottom-1/4 transform -translate-y-1/2"
              src={ArrowRightSvg}
            />
          }
          content={
            <>
              <span className="text-primary">{t('subMessage1')}</span>
              {t('subMessage2')}
              <a
                className="link-primary link-offset-2 link-underline-opacity-0 link-underline-opacity-100-hover"
                href={processInfo?.recruitmentUrl}
              >
                {t('here')}
              </a>
              .
              <p className="pt-2">
                {t('subMessage3')}
                <span className="text-primary"> {t('subMessage4')}</span>
                {t('subMessage5', { contactEmail: processInfo?.contactEmail })}
              </p>
              <p>{t('subMessage6')}</p>
            </>
          }
          message={t('heading')}
        />
        <ButtonWithLoading onClick={handleFinish}>{t('buttons.finish')}</ButtonWithLoading>
      </div>
      <div className="-mt-20">
        <img
          alt="happy-robot"
          className="w-full"
          src={`${generateNonCachableImageSrc(HappyRobotSvg)}`}
        />
      </div>
    </div>
  );
};

export default FinalMessageDesktop;
